module.exports = __webpack_public_path__ + "img/instagram.dd11ddd0.png";